import { defineComponent as _defineComponent } from 'vue'
import { processedUrl } from '@padlet/vivaldi-client'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'processed_image',
  props: {
    src: null,
    width: null,
    height: null,
    transforms: null,
    alt: { default: '' }
  },
  emits: ["error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'error', error: Event): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { src: string, width: number, height: number, transforms: { [key: string]: string | number }, alt: string };





const processedSrc = computed(() => {
  // For relative urls in development
  if (props.src.startsWith('/')) return props.src

  const purl = processedUrl(props.src, props.transforms)
  return purl
})

function onError(error: Event) {
  emit('error', error)
}

return { __sfc: true,props, emit, processedSrc, onError }
}

})